var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisable === false)?_c('md-button',{staticClass:"md-raised md-accent",staticStyle:{"visibility":"hidden"}},[_vm._v("0")]):_c('md-button',{staticClass:"md-raised md-accent",attrs:{"disabled":_vm.value === 0},on:{"click":_vm.callClick}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }